import './WhatsAppFloat.css';
// import { FaWhatsapp } from "react-icons/fa";

// TODO: numero de WhatsApp perdido. El boton flotante queda deshabilitado
// hasta conseguir una linea nueva. Para reactivarlo: descomentar el bloque de
// abajo, restaurar el import de FaWhatsapp y poner el numero nuevo en el href.
const WhatsAppFloat = () => null;

/*
const WhatsAppFloat = () => (
  <a
    href="https://wa.me/NUEVO_NUMERO"
    className="whatsapp-float"
    target="_blank"
    rel="noopener noreferrer"
    title="¡Chatea con nosotros por WhatsApp!"
  >
    <FaWhatsapp size={38} />
  </a>
);
*/

export default WhatsAppFloat;
